import { Button } from "@/components/ui/button";
import { ArrowRight, Pencil, UserCog, Power, Building2, AlertTriangle } from "lucide-react";

const STAT = [
  ["pekerja", "Pekerja"], ["spl_menunggu", "SPL Menunggu"], ["cuti_menunggu", "Cuti Menunggu"],
  ["tagihan_belum_bayar", "Tagihan Belum Bayar"], ["kontrak_akan_habis", "Kontrak ≤60 hari"], ["helpdesk_terbuka", "Helpdesk Terbuka"],
];
const WARN = new Set(["spl_menunggu", "cuti_menunggu", "tagihan_belum_bayar", "kontrak_akan_habis", "helpdesk_terbuka"]);

export default function AreaCard({ area, onMasuk, onEdit, onAdmin, onToggleAktif, readOnly = false }) {
  const r = area.ringkasan || {};
  return (
    <div className={`rounded-xl border bg-white p-5 space-y-4 transition-colors ${area.aktif ? "border-slate-200 hover:border-blue-300" : "border-slate-200 opacity-60"}`} data-testid={`area-card-${area.kode}`}>
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center shrink-0"><Building2 className="h-5 w-5" /></div>
        <div className="min-w-0">
          <p className="font-bold text-slate-900 leading-tight truncate" data-testid={`area-nama-${area.kode}`}>{area.nama}</p>
          <p className="text-[11px] text-slate-500 truncate">{area.kode} · dipilih saat login{area.is_default ? " · area utama" : ""}</p>
        </div>
        <div className="ml-auto flex items-center gap-1">
          {area.is_default && <span className="rounded-full bg-blue-100 text-blue-700 px-2 py-0.5 text-[10px] font-bold">UTAMA</span>}
          {!area.aktif && <span className="rounded-full bg-rose-100 text-rose-700 px-2 py-0.5 text-[10px] font-bold">NONAKTIF</span>}
        </div>
      </div>
      {r.ok === false ? <p className="text-xs text-rose-600 flex items-center gap-1"><AlertTriangle className="h-3.5 w-3.5" />Ringkasan tidak tersedia</p> : (
        <dl className="grid grid-cols-3 gap-2">
          {STAT.map(([k, l]) => (
            <div key={k} className="rounded-lg bg-slate-50 border border-slate-100 px-2.5 py-2">
              <dt className="text-[10px] text-slate-500 leading-tight">{l}</dt>
              <dd className={`text-lg font-black tabular-nums ${WARN.has(k) && r[k] > 0 ? "text-amber-600" : "text-slate-900"}`} data-testid={`area-stat-${area.kode}-${k}`}>{r[k] ?? "–"}</dd>
            </div>
          ))}
        </dl>
      )}
      {readOnly ? <p className="text-[11px] text-slate-400 pt-1" data-testid={`area-readonly-${area.kode}`}>Mode lihat saja</p> : (
      <div className="flex items-center gap-1.5 pt-1">
        <Button size="sm" onClick={onMasuk} disabled={!area.aktif} className="h-9 gap-1.5 bg-blue-600 hover:bg-blue-700 text-white flex-1" data-testid={`area-masuk-${area.kode}`}>Masuk ke Area<ArrowRight className="h-4 w-4" /></Button>
        <Button size="icon" variant="outline" onClick={onEdit} title="Ubah nama area" className="h-9 w-9 border-slate-200" data-testid={`area-edit-${area.kode}`}><Pencil className="h-4 w-4" /></Button>
        <Button size="icon" variant="outline" onClick={onAdmin} title="Buat / reset admin area" className="h-9 w-9 border-slate-200 text-blue-700" data-testid={`area-admin-${area.kode}`}><UserCog className="h-4 w-4" /></Button>
        {!area.is_default && <Button size="icon" variant="outline" onClick={onToggleAktif} title={area.aktif ? "Nonaktifkan area" : "Aktifkan area"} className={`h-9 w-9 border-slate-200 ${area.aktif ? "text-rose-600" : "text-emerald-600"}`} data-testid={`area-toggle-${area.kode}`}><Power className="h-4 w-4" /></Button>}
      </div>)}
    </div>
  );
}
